"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BotSkillType = void 0;
var BotSkillType;
(function (BotSkillType) {
  BotSkillType["IDENTITY"] = "IDENTITY";
  BotSkillType["ROUTING"] = "ROUTING";
  BotSkillType["HELLO"] = "HELLO";
  BotSkillType["EMAIL"] = "EMAIL";
  BotSkillType["HELP"] = "HELP";
  BotSkillType["CREATE_TICKET"] = "CREATE_TICKET";
  BotSkillType["SCHEDULING"] = "SCHEDULING";
  BotSkillType["THANK_YOU"] = "THANK_YOU";
  BotSkillType["EMAIL_CAPTURE"] = "EMAIL_CAPTURE";
  BotSkillType["ENTERPRISE"] = "ENTERPRISE";
  BotSkillType["SUPPORT"] = "SUPPORT";
  BotSkillType["STATEMENT"] = "STATEMENT";
  BotSkillType["EMAIL_CAPTURE_QUESTION"] = "EMAIL_CAPTURE_QUESTION";
  BotSkillType["QUESTION"] = "QUESTION";
  BotSkillType["CONDITIONAL"] = "CONDITIONAL";
  BotSkillType["END_OF_CONVERSATION"] = "END_OF_CONVERSATION";
  BotSkillType["PHONE_CAPTURE"] = "PHONE_CAPTURE";
  BotSkillType["BLOCK_VERSION"] = "BLOCK_VERSION";
  BotSkillType["BLOCK"] = "BLOCK";
  BotSkillType["WEBHOOK"] = "WEBHOOK";
})(BotSkillType = exports.BotSkillType || (exports.BotSkillType = {}));